import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from '../detail/milestone/index.module.scss'
import clsx from "clsx";
import { getProjectMilestonesApi, getMilestonePlanWarnNodeApi } from '@/services'
import { useRequest } from 'ahooks'
import { useParams, useSearchParams } from "react-router-dom"
import { DatePicker, Space, Modal, ConfigProvider, Button, Popover, message } from 'antd';
import Edit from '../detail/milestone/edit'
import { k_milestoneStatus } from '../detail/milestone/edit'
import { ThEmpty } from '@/components';
import { PlotEditPopup } from "../detail/milestone/plot"
import { getMilestoneDataNew } from "../detail/milestone/index"


const getPrecentStr = (num: number) => {
    if (num === 0) return "0%"
    if (num * 100 < 1) return (num * 100).toFixed(2) + "%"
    return Math.floor(num * 100) + "%"
}
const getPrecentNum = (num: number) => {
    if (num === 0) return 0
    if (num * 100 < 1) return Number((num * 100).toFixed(2))
    return Math.floor(num * 100)
}
export interface MilestoneRender extends API.PROJECT.Milestone{
    precent: string,
    precentNum: number,
    outDate: boolean,
    overDueDays: number,
    date: string,
    isWarn?: boolean,
}
export interface MilestonePlotItem {
    plot: ProjectMilestonePlot,
    milestones: MilestoneRender[]
}

interface IMilestoneProps{
    data?: MilestoneRender[],
    className?: string
}
export const Milestone: React.FC<IMilestoneProps> = (props) => {
    const contentRef = useRef<HTMLDivElement>(null)
    const [itemWidth, setItemWidth] = useState(document.documentElement.clientWidth)
    useEffect(() => {
        const resize = () => {
            if (contentRef.current) {
                const width = contentRef.current.clientWidth
                setItemWidth(width / (props.data?.length || 1))
            }

        }
        window.addEventListener('resize', resize)

        return () => {
            window.removeEventListener('resize', resize)
        }
    }, [props.data])
    return (
        <div className={`flex items-center overflow-x-auto overflow-y-hidden px-8 pt-16 pb-4 ${props.className || ''}`} ref={contentRef}>
            {props.data?.map((item, index) => (
                <div key={index} className={clsx(styles['timeline-item'], item.statusNum === k_milestoneStatus.finished ? styles['is-outdate'] : (item.outDate ? styles['is-overdue'] : ''))}>
                    
                    <div>
                        <span className={clsx(styles['timeline-item-label'], item.isWarn ? 'text-red-500' : '')}>
                            {item.actualDate || item.milestoneDate}
                        </span>
                    </div>

                    <div className={styles['timeline-item-sep']}>
                        {index > 0 && (
                            <div className={styles['timeline-item-line-box']}>
                                <div className={styles['timeline-item-line']}>
                                    <div className={styles['timeline-item-line-animate']}></div>
                                </div>
                            </div>
                        )}
                        {item.outDate && item.statusNum === k_milestoneStatus.unstart ? (
                            <Popover content={
                                <div>
                                    <div className="font-bold">{item.milestoneName}</div>
                                    <div>计划完成日期: <span className="text-blue-400 font-bold">{item.milestoneDate}</span>, 延期 <span className="text-red-500 font-bold">{item.overDueDays}</span> 天</div>
                                </div>
                            } trigger="hover">
                                <div className={clsx(styles['timeline-item-taild'])}></div>
                            </Popover>
                        ) : (
                            <div className={clsx(styles['timeline-item-taild'])}></div>
                        )}

                    </div>
                    <div className={styles['timeline-item-content']} style={{maxWidth: itemWidth, width: index === 0 ? itemWidth : '' }}>
                        <div className={`two-line-clamp ${item.isWarn ? 'text-red-500' : ''}`}>{item.milestoneName}</div>
                        <div className={`text-xs ${item.isWarn ? 'text-red-500' : ''}`}>{item.precent}</div>
                        {item.isAutoCompleted && (
                            <div className="text-green-700 text-xs">系统按照开票情况完成</div>
                        )}
                        
                    </div>
                </div>
            ))}
        </div>
    )
}

const Index = () => {
    const params = useParams()
    const projectID = params.projectID || -1
    const [searchParams] = useSearchParams();
    const invoiceToken = searchParams.get('token') || '';
    
    const { data: dataList, run, loading, refresh } = useRequest(getMilestoneDataNew, {
        defaultParams: [projectID, invoiceToken]
    })
    const { data: warnNode, run: runWarnNodes, loading: warnLoading } = useRequest(getMilestonePlanWarnNodeApi, {
        defaultParams: [invoiceToken]
    })
    const list = useMemo(() => {
        if (!dataList || dataList.length <= 0) return []
        return dataList.map((v) => {
           const index = v.milestones.findIndex(item => item.milestoneCode === warnNode?.milestoneCode)
           return {
               ...v,
               milestones: v.milestones.map((item, i) => ({
                   ...item,
                   isWarn: item.status !== k_milestoneStatus.finished && i <= index
               }))
           }
        })
    }, [dataList, warnNode])
   
    const [editModalVisible, setEditModalVisible] = useState(false)

    const onEditComplete = () => {
        run(projectID, invoiceToken)
        setEditModalVisible(false)
    }
    const onEdit = (item: MilestonePlotItem) => {
        if (!list || list.length <= 0) return
        setCurrentPlot(item)
        setEditModalVisible(true)
    }
    const noData = useMemo(() => {
        return !loading && (!list || list.length <= 0)
    }, [loading, list])

    const [plotVisible, setPlotVisible] = useState(false)
    const allPlots = useMemo(() => {
        if (!list || list.length <= 0) return []
        return list.map(v => v.plot).filter(v => v && v.ID > 0)
    }, [list])

    // 编辑地块
    const onEditPlot = () => {
        if (!list || list.length <= 0) return
        let hasSetting = false
        list.forEach(v => {
            v.milestones.forEach(item => {
                if (item.milestoneDate || item.actualDate) {
                    hasSetting = true
                }
            })
        })
        if (!hasSetting) {
            message.warning("请先设置节点时间和状态")
            return
        }
        setPlotVisible(true)
    }

    const [currentPlot, setCurrentPlot] = useState<MilestonePlotItem>()

    return (
        <>
            {!noData && (
                <div className="mb-4 flex items-center gap-2">
                    <Button type="primary" className="ml-4" onClick={onEditPlot}>
                        设置地块
                    </Button>
                    <span className="text-[12px] text-black/50 ml-2">*仅在项目需要分期/分地块，但又无法新立项时使用。设置后，每个地块将拥有独立的标准里程碑进度跟踪线路。</span>
                </div>
            )}
            {list?.map(v => (
                <div key={v.plot?.ID} className="mb-4">
                    <div className="flex items-center gap-2">
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimary: "#047857",
                                }
                            }}>
                            <Button type="primary" className="ml-4" onClick={() => onEdit(v)}>
                                设置节点时间与状态
                            </Button>

                        </ConfigProvider>
                        <div className="font-bold">{v.plot?.plotName} {v.plot?.ID ? `(${v.plot?.percentage * 100}%)` : ""}</div>
                    </div>
                    <Milestone data={v.milestones} />
                </div>
            ))}
            {noData && (
                <ThEmpty
                    className="mt-4"
                    description={(
                        <div className="text-black/50 mt-4">
                            暂无数据
                        </div>
                    )}
                />
            )}
            <Modal title="节点时间与状态设置" width="fit-content" destroyOnHidden style={{ minWidth: 750 }} open={editModalVisible} onCancel={() => setEditModalVisible(false)} footer={null}>
                <Edit isPlanList={true} values={currentPlot?.milestones} projectID={projectID} plotID={currentPlot?.plot.ID} onUpdate={onEditComplete} onCancel={() => setEditModalVisible(false)}></Edit>
            </Modal>
            <PlotEditPopup visible={plotVisible} onClose={() => setPlotVisible(false)} onUpdate={refresh} projectID={projectID} plots={allPlots} />
        </>
    )
}
export default Index